import React from 'react';
import Container from 'container';
import Headline from 'headline';
import s from './lp_info_cards.module.scss';

export default function InfoCards({
  main_title,
  cards
}) {
  return (
    <>
      <Container className={s.root}>
        <div className={s.wrapper}>
          {/* Main Title */}
          <Headline className={s.mainTitle} h2 center black>{main_title}</Headline>

          {/* Cards */}
          <div className={s.cardWrapper}>
            {cards.map(({ text }, index) => (
              <div className={s.card}>
                {/* Number Circle */}
                <div className={s.cardNumber}>{index}</div>

                {/* Card text */}
                <p className={s.text}>{text}</p>
              </div>
            ))}
          </div>
        </div>
      </Container>

      <hr className={s.line} />
    </>
  );
}
